import "../account-management.module.css";

import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";
import validator from "validator";

// Slice
import { uiActions, selectShowModalSpinner } from "stores/slice/ui";

// UI
import SpinnerForModal from "ui/SpinnerForModal";

// Component
import Button from "components/Button";
import Input from "components/Input";
import ModalContainer from "components/ModalContainer";
import MessageBoxGroup from "components/MessageBoxGroup";

// Controller
import controller from "../controller";

// Default variable
const defaultMessages = {
  error: ''
};

const ResendVerificationEmailModal = props => {
  const { t } = useTranslation();

  const {
    modalStatus,
    changeModalStatus,
    selectedAccount,
    successCallback
  } = props;
  const dispatch = useDispatch();
  const showModalSpinner = useSelector(selectShowModalSpinner);

  const [messages, setMessages] = useState(cloneDeep(defaultMessages));
  const [email, setEmail] = useState('');
  const [valid, setValid] = useState(true);

  const changeEmail = (value) => {
    validator.isEmail(value) ? setValid(true) : setValid(false);
    setEmail(value);
  }

  const resend = async () => {
    dispatch(uiActions.showModalSpinner());

    try {
      const response = await controller.resendEmail(selectedAccount.id, email);

      if (response.error) {
        throw response.error;
      }

      dispatch(uiActions.hideModalSpinner());
      setMessages(cloneDeep(defaultMessages));
      changeModalStatus('resendVerificationEmail', false);
      successCallback();
    } catch (error) {
      setMessages({
        ...messages,
        error: error.code,
        success: null,
      });
      dispatch(uiActions.hideModalSpinner());
    }
  }

  useEffect(() => {
    selectedAccount && setEmail(selectedAccount.email);
  }, [selectedAccount])

  return (
    <ModalContainer
      modalWidthType="modal-400px"
      openModal={modalStatus.resendVerificationEmail.status}
      closeModal={() => changeModalStatus('resend', false)}
    >
      {showModalSpinner && <SpinnerForModal />}
      <div className="header">
        <div className="title">{t('b451caa3da')}</div>
      </div>
      <div className="body">
        <MessageBoxGroup
          messages={messages}
          ErrorMessagesType='es'
          SuccessMessagesType='i18n'
          WarningMessagesType='i18n'
          onClose={(value) => setMessages({ ...defaultMessages, [value]: null })}
        />
        {/* Email address* */}
        <div className="mb-3">
          <div className="modal-form-group pt-2">
            <div className="modal-form-title required me-3">{t('ce8ae9da5b')}</div>
            <div className="modal-form-field">
              <Input
                type="text"
                placeholder="7563cde047"
                value={email}
                isInvalid={!valid}
                onChange={e => changeEmail(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Button
          label="ea4788705e"
          className="btn-cancel"
          onClick={() => changeModalStatus('resendVerificationEmail', false)}
        />
        <Button
          label="1c0b8f236c"
          className="btn-submit"
          disabled={!valid}
          onClick={resend}
        />
      </div>
    </ModalContainer>
  );
};

export default ResendVerificationEmailModal;
